(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latte-trio"] && !Shopify.designMode) return;
  try {
    
function openLatteProductInfo() {
  const id = window.location.hash.slice(1);
  if (!id.startsWith('lt-info-')) return;
  const panel = document.getElementById(id);
  if (panel instanceof HTMLDetailsElement) panel.open = true;
}
window.addEventListener('hashchange', openLatteProductInfo);
openLatteProductInfo();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matcha-campaign"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('matcha-landing')) {
 class MatchaLanding extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   const format = cents => new Intl.NumberFormat(this.dataset.locale || 'de', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(cents / 100);
   const milk = this.querySelector('[data-milk]');
   const sort = this.querySelector('[data-calc-sort]');
   const updateCosts = () => {
    const cost = milk.valueAsNumber;
    const price = Number(sort.dataset.price);
    const valid = Number.isFinite(cost) && cost >= 0 && cost <= 20 && sort.value !== '' && Number.isFinite(price);
    this.querySelector('[data-calc-error]').hidden = valid;
    milk.setAttribute('aria-invalid',String(!valid));
    this.querySelector('[data-cost-concentrate]').textContent = valid ? format(price / 100) : '–';
    this.querySelector('[data-cost-milk]').textContent = valid ? format(cost * 15) : '–';
    this.querySelector('[data-cost-total]').textContent = valid ? format(price / 100 + cost * 15) : '–';
   };
   milk.addEventListener('input',updateCosts);
   updateCosts();
   const publish = (name,detail) => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed?.() || !privacy?.marketingAllowed?.()) return;
    try {window.Shopify?.analytics?.publish?.(name,{landing_version:this.dataset.version,...detail});} catch (_) {}
   };
   this.querySelectorAll('[data-cta]').forEach(a=>a.addEventListener('click',()=>publish('purecha_landing_cta',{position:a.dataset.cta})));
   const syncOffer = r => {
    if(!r)return;
    const total=Number(r.dataset.offerPrice);
    this.querySelectorAll('[data-offer-total],[data-sticky-total]').forEach(el=>el.textContent=format(total));
    const stickyQuantity=this.querySelector('[data-sticky-quantity]');
    if(stickyQuantity)stickyQuantity.textContent=r.dataset.offerLabel;
   };
   this.querySelectorAll('[data-offer-quantity]').forEach(r=>r.addEventListener('change',()=>{
    syncOffer(r);
    publish('purecha_landing_offer',{quantity:Number(r.value),value:Number(r.dataset.offerPrice)/100});
   }));
   syncOffer(this.querySelector('[data-offer-quantity]:checked'));
   const privacyButton=this.querySelector('[data-privacy-settings]');
   const revealPrivacy=()=>{if(window.Shopify?.customerPrivacy?.showPreferences){privacyButton.hidden=false;}};
   revealPrivacy();document.addEventListener('visitorConsentCollected',revealPrivacy);
   privacyButton.addEventListener('click',()=>window.Shopify?.customerPrivacy?.showPreferences?.());
   const form=this.querySelector('[data-landing-form]');
   if(!form)return;
   form.addEventListener('submit',async event=>{
    if (!form.reportValidity()) return;
    event.preventDefault();
    if(this.submitting)return;
    this.submitting=true;
    const button=form.querySelector('button[type="submit"]');
    const trigger=event.submitter || button;
    const data=new FormData(form);
    const controls=[button,...this.querySelectorAll('[data-sticky-submit]')].map(control=>({control,disabled:control.disabled,label:control.querySelector('[data-add-label]'),text:control.querySelector('[data-add-label]').textContent}));
    const choices=Array.from(form.querySelectorAll('[data-offer-quantity]')).map(control=>({control,disabled:control.disabled}));
    const error=this.querySelector('[data-cart-error]');
    const success=this.querySelector('[data-cart-success]');
    error.hidden=true;success.hidden=true;
    controls.forEach(({control,label})=>{control.disabled=true;control.setAttribute('aria-busy','true');label.textContent=this.dataset.adding;});
    choices.forEach(({control})=>control.disabled=true);
    try {
     const id=data.get('id');const quantity=Number(data.get('quantity'));
     if(!id || !Number.isInteger(quantity) || quantity<1 || quantity>100)throw new Error(this.dataset.error);
     const properties=Object.fromEntries(Array.from(data.entries()).filter(([key])=>/^properties\[[^\]]+\]$/.test(key)).map(([key,value])=>[key.slice(11,-1),value]));
     const response=await fetch(this.dataset.cartAdd+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity,properties}]}),credentials:'same-origin'});
     const result=await response.json();
     if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);
     publish('purecha_landing_add',{variant_id:id,quantity});
     let drawerOpened=false;
     if(window.PurechaCart?.refresh && window.PurechaCart?.open){
      try {
       const cart=await window.PurechaCart.refresh();
       if(cart){window.PurechaCart.open(trigger);drawerOpened=true;}
      } catch (_) {}
     }
     if(!drawerOpened){success.hidden=false;success.focus({preventScroll:true});success.scrollIntoView({block:'nearest',behavior:'smooth'});}
    } catch(e) {
     error.textContent=e.message || this.dataset.error;error.hidden=false;
     error.setAttribute('tabindex','-1');error.focus({preventScroll:true});error.scrollIntoView({block:'center',behavior:'smooth'});
    } finally {
     this.submitting=false;
     controls.forEach(({control,disabled,label,text})=>{control.disabled=disabled;control.removeAttribute('aria-busy');label.textContent=text;});
     choices.forEach(({control,disabled})=>control.disabled=disabled);
    }
   });
  }
 }
 customElements.define('matcha-landing',MatchaLanding);
}


  } catch(e) { console.error(e); }
})();
})();
